export * from './authFederatedSignIn';
export * from './authSignOut';
export * from './getCurrentSession';
// export * from './getSTSCredentials';
export * from './getSTSCurrentUser';
export * from './ISTSCredentials';
export * from './configure';
export * from './isMemberOf';
